import FeaturedDestinationContainer from '../../../../components/containers/FeaturedDestinationContainer';
import deepmerge from '../../../utils/deepmerge';
import preloadCustomProps from '../../../utils/preloads/preloadFeaturedDestinations';

const cmpConfig = {
  name: 'featured-destination',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: FeaturedDestinationContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
